<template>
  <div class="banner">
    <swiper :options="bannerSwiperOption">
      <swiper-slide class="banner-item banner-g">
        <div class="banner-main" style="cursor: pointer;" @click="enter('/solution/ComputePower')">
          <div class="compute-power-text">
            <img src="../../../assets/home/newbanner/computepower/text.png" />
          </div>
          <img src="../../../assets/home/newbanner/computepower/btn.png" class="compute-power-btn" />
        </div>
      </swiper-slide>
      <swiper-slide class="banner-item banner-d">
        <div class="banner-main " style="cursor: pointer;" @click="enter('/resource/IdcJianDeNew')">
          <div class="jd-idc-title">
            浙西智算中心<br />
            三期大楼成功落地
          </div>
          <div class="jd-idc-sm-title">JIANDE TONGHANG CLOUD DATA CENTER</div>
          <button class="jd-idc-btn">了解更多</button>
        </div>
      </swiper-slide>
      <swiper-slide class="banner-item banner-f">
        <div class="banner-main" style="cursor: pointer;" @click="enter('/resource/WanCCS')"></div>
      </swiper-slide>
      <!-- <swiper-slide class="banner-item banner-a">
        <div class="banner-main">
          <div class="banner-btns" style="bottom:120px;">
            <div
              class="banner-btn-item"
              @click="open({itemName: '申请SD-WAN免费测试',buType: 6,items: ['description'],})"
            >免费试用</div> -->
      <!-- <div class="banner-btn-item" @click="watchVideo">观看视频</div> -->
      <!-- <div class="banner-btn-item" @click="enter('/documents')">产品文档</div> -->
      <!-- </div>
        </div>
      </swiper-slide> -->
      <!-- <swiper-slide class="banner-item banner-d">
        <div class="banner-main " style="cursor: pointer;" @click="enter('/resource/IdcJianDe')">
        </div>
      </swiper-slide> -->
      <swiper-slide class="banner-item banner-c">
        <div class="banner-main" style="cursor: pointer;" @click="enter('/resource/IdcXiaSha')">
          <!-- <div class="text-box">
            <h3>2021年度SD-WAN峰会</h3>
            <h2>新锐企业奖</h2>
            <p>CUTTING EDGE ENTERPRISE AWARD</p>
          </div> -->
        </div>
      </swiper-slide>
      <!-- <swiper-slide class="banner-item banner-b">
        <div class="banner-main" style="cursor: pointer;" @click="enter('/resource/IdcFudi')">
        </div>
      </swiper-slide> -->
    </swiper>
    <div class="pagination-wrap">
      <div class="banner-pagination"></div>
    </div>
    <div v-if="videoFlag" class="video-outer" @mouseover="forbidenScroll">
      <div class="video">
        <span @click="watchVideo">×</span>
        <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
      </div>
    </div>
    <theForm ref="theForm"></theForm>
    <!-- <div class="qrcode" v-if="showQRcode" @click="openQRcode">
      <img
        src="../../../assets/home/banner/qrcode.png"
        alt=""
        class="theqrcode"
      />
    </div>-->
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import theForm from "../../../components/form";
export default {
  components: { swiper, swiperSlide, theForm },
  data() {
    return {
      videoFlag: false,
      showQRcode: false,
      bannerSwiperOption: {
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false
        // },
        loop: true,
        effect: "fade",
        pagination: {
          el: ".banner-pagination",
          type: "bullets",
          clickable: true,
        },
      },
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "https://file.netbank.cn/XUANCHUAN.mp4", //url地址
            // src:"https://software.netbank.cn/video/09-Kubernetes%20Pod%E6%8E%A7%E5%88%B6%E5%99%A8.mp4"
          },
        ],
        // poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  methods: {
    open(data) {
      this.$refs.theForm.open(data);
    },
    enter(url) {
      let a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("id", "startTelMedicine");
      a.setAttribute("target", "_blank");
      // 防止反复添加
      if (document.getElementById("startTelMedicine")) {
        document.body.removeChild(document.getElementById("startTelMedicine"));
      }
      document.body.appendChild(a);
      a.click();
    },
    moving() {
      const win = window;
      const doc = document.documentElement;

      doc.classList.remove("no-js");
      doc.classList.add("js");

      // Reveal animations
      if (document.body.classList.contains("has-animations")) {
        /* global ScrollReveal */
        const sr = (window.sr = ScrollReveal());

        sr.reveal(".hero-title, .hero-paragraph, .hero-form", {
          duration: 1000,
          distance: "40px",
          easing: "cubic-bezier(0.5, -0.01, 0, 1.005)",
          origin: "bottom",
          interval: 150,
        });
      }

      // 选取元素
      const movingObjects = document.querySelectorAll(".is-moving-object");

      // 节流函数
      function throttle(func, milliseconds) {
        let lastEventTimestamp = null;
        let limit = milliseconds;

        return (...args) => {
          let now = Date.now();

          if (!lastEventTimestamp || now - lastEventTimestamp >= limit) {
            lastEventTimestamp = now;
            func.apply(this, args);
          }
        };
      }
      // 初始化参数
      let mouseX = 0;
      let mouseY = 0;
      let scrollY = 0;
      let coordinateX = 0;
      let coordinateY = 0;
      let winW = doc.clientWidth;
      let winH = doc.clientHeight;

      // 移动方法
      function moveObjects(e, object) {
        mouseX = e.pageX;
        mouseY = e.pageY;
        scrollY = win.scrollY;
        coordinateX = winW / 2 - mouseX;
        coordinateY = winH / 2 - (mouseY - scrollY);
        // console.log(mouseX);
        // console.log(mouseY);

        for (let i = 0; i < object.length; i++) {
          const translatingFactor = object[i].getAttribute("data-translating-factor") || 100;
          const rotatingFactor = object[i].getAttribute("data-rotating-factor") || 150;
          const perspective = object[i].getAttribute("data-perspective") || 500;
          let tranformProperty = [];

          if (object[i].classList.contains("is-translating")) {
            tranformProperty.push("translate(" + coordinateX / translatingFactor + "px, " + coordinateY / translatingFactor + "px)");
          }

          if (object[i].classList.contains("is-rotating")) {
            tranformProperty.push("perspective(" + perspective + "px) rotateY(" + -coordinateX / rotatingFactor + "deg) rotateX(" + coordinateY / rotatingFactor + "deg)");
          }

          if (object[i].classList.contains("is-translating") || object[i].classList.contains("is-rotating")) {
            tranformProperty = tranformProperty.join(" ");

            object[i].style.transform = tranformProperty;
            object[i].style.transition = "transform 0.4s ease-out";
            object[i].style.transformStyle = "preserve-3d";
            object[i].style.backfaceVisibility = "hidden";
          }
        }
      }

      // 调用节流
      if (movingObjects) {
        win.addEventListener(
          "mousemove",
          throttle(function(e) {
            moveObjects(e, movingObjects);
          }, 150)
        );
      }
    },
    getBannerHeight() {
      let theHeight = window.screen.height - 143;
      let bannerH = document.getElementsByClassName("banner");
      let bannerItemH = document.getElementsByClassName("banner-item");
      bannerH[0].style.height = theHeight + "px";

      for (let i = 0; i < bannerItemH.length; i++) {
        bannerItemH[i].style.height = theHeight + "px";
      }
    },
    forbidenScroll() {
      var html = document.getElementsByTagName("html");
      html[0].style.overflow = "hidden";
      // html[0].style.marginRight = "17px";
    },
    reScroll() {
      var html = document.getElementsByTagName("html");
      html[0].style.overflow = "auto";
    },
    watchVideo() {
      this.videoFlag = !this.videoFlag;
      if (this.videoFlag == false) {
        this.reScroll();
      }
    },
  },
  mounted() {
    // this.moving();
    // this.getBannerHeight();
  },
};
</script>
<style lang="less" scoped>
.banner {
  height: 600px;
  padding-top: 80px;
  width: 100%;
  position: relative;
  background-color: #8a8a8a;

  .banner-main {
    width: 1200px;
    height: 100%;
    // background-color: #000;
    margin: 0 auto;
    position: relative;
  }

  .banner-item {
    height: 520px;
    width: 100%;
    background-color: #fff;
    color: #000;
  }
  .banner-btns {
    display: flex;
    justify-content: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    .banner-btn-item {
      width: 120px;
      color: #fff;
      cursor: pointer;
      font-weight: 300;
      font-size: 20px;
      transition: 0.3s;
      text-align: center;
      border-right: 1px solid #fff;

      &:hover {
        font-weight: 800;
      }
      &:nth-last-child(1) {
        border: none;
      }
    }
  }
  .banner-a {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/home/newbanner/bannera.jpg");
  }
  .banner-b {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/home/newbanner/fdbanner.jpg");
  }
  .banner-c {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/home/newbanner/xsbanner.jpg");
    .banner-main {
      // background-color: #fff;
      .text-box {
        color: #fff;
        font-weight: 600;
        text-align: center;

        position: absolute;
        left: 380px;
        top: 140px;

        h3 {
          font-size: 35px;
          margin-bottom: 24px;
          text-shadow: 0px 5px 10px rgba(0, 0, 0, 0.38);
        }
        h2 {
          font-size: 106px;
          margin-bottom: 20px;
          text-shadow: 0px 5px 10px rgba(0, 0, 0, 0.38);
        }
        p {
          font-size: 26px;
        }
      }
    }
  }
  .banner-d {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/home/newbanner/thybanner_01.png");
  }

  .banner-e {
  }
  .banner-f {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/home/newbanner/bannerf.jpg");
  }
  .banner-g {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/home/newbanner/computepower/bg.png");
    // .banner-main {
    //   width: auto;
    //   margin: 0 200px;
    // }
    .compute-power-text {
      margin-top: 150px;
      img {
        height: 130px;
      }
    }
    .compute-power-btn {
      margin-top: 30px;
      height: 36px;
    }
  }

  .btns {
    width: 220px;
    margin: 0 auto;
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: space-around;
  }
  .deep {
    width: 90px;
    font-size: 16px;
    color: #fff !important;
    border: 1px solid #c3191f !important;
    background-color: #c3191f !important;
    &:hover {
      border: 1px solid #f72d2d !important;
      background-color: #f72d2d !important;
    }
  }

  .banner-button {
    width: 100px;
    height: 30px;
    color: #333;
    font-size: 18px;
    display: inline-block;
    text-align: center;
    line-height: 30px;
    border: 1px solid #333;
    transition: all 0.3s;
    cursor: pointer;
    &:hover {
      background-color: #333;
      color: #fff;
    }
  }
  .single {
    width: 102px;
    height: 32px;
    background-color: #fff;
    color: #fff;
    border: none;
    background: linear-gradient(0deg, #cb271f, #e3491c);
    &:hover {
      color: #fff;
    }
  }
  .pagination-wrap {
    position: absolute;
    left: 50%;
    bottom: 10px;
    z-index: 1;
    transform: translateX(-50%);

    .banner-pagination {
      /deep/.swiper-pagination-bullet {
        height: 4px;
        width: 20px !important;
        margin-right: 6px;
        opacity: 0.4;
        border-radius: 5px;
        background-color: #d9d9d9 !important ;
        outline: none;
        transition: all 0.3s;
      }
      /deep/.swiper-pagination-bullet-active {
        width: 32px !important;
        opacity: 1;
        background-color: #fff !important ;
        outline: none;
      }
    }
  }
  .video-outer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2000px;
    z-index: 999;
    overflow: hidden;
    background-color: rgba(26, 26, 26, 0.65);
    -webkit-transition: background-color 0.3s ease-out;
    transition: background-color 0.3s ease-out;
    .video {
      position: fixed;
      width: 960px;
      height: 540px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      background-color: #000;
      span {
        cursor: pointer;
        position: absolute;
        right: 15px;
        top: 0px;
        color: #fff;
        font-size: 30px;
        z-index: 999;
      }
    }
  }

  .qrcode {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2000px;
    z-index: 999;
    overflow: hidden;
    background-color: rgba(26, 26, 26, 0.65);
    -webkit-transition: background-color 0.3s ease-out;
    transition: background-color 0.3s ease-out;
    .theqrcode {
      width: 500px;
      position: fixed;
      left: 50%;
      transform: translateX(-50%);
      top: 20%;
    }
  }
}
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 1920px;
  height: 300px;
}

.jd-idc-title {
  width: 450px;
  font-weight: bold;
  line-height: 54px;
  color: #003b94;
  font-size: 40px;
  margin-top: 150px;
  font-family: HYQiHei;
}
.jd-idc-sm-title {
  font-size: 13px;
  margin-top: 34px;
  font-family: Arial;
  color: #003b94;
}

.jd-idc-btn {
  border: 1px solid #003b94;
  padding: 6px 19px;
  color: #003b94;
  margin-top: 35px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/banner.vue